import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { CLAIM_EMAIL_APPROVAL_NOTIFICATION_TYPE } from '../actions';
import { approveAndSendClaimEmail } from './claimNotificationHelpers';

interface ClaimNotificationActionsProps {
  notificationType: string;
  claimId: string | null;
  notificationSiteId: number;
  siteExtId: string;
  operatorGroup: any;
  onMarkAsRead: () => void;
  onClose: () => void;
}

export const ClaimNotificationActions: React.FC<ClaimNotificationActionsProps> = ({
  notificationType,
  claimId,
  notificationSiteId,
  siteExtId,
  operatorGroup,
  onMarkAsRead,
  onClose,
}) => {
  const history = useHistory();
  const intl = useIntl();
  const dispatch = useDispatch();
  const isClaimEmailApproval = notificationType === CLAIM_EMAIL_APPROVAL_NOTIFICATION_TYPE;

  const handleApproveAndSendEmail = () => {
    approveAndSendClaimEmail({
      claimId,
      notificationSiteId,
      operatorGroup,
      dispatch,
      onSuccess: () => {
        onMarkAsRead();
        onClose();
      },
    });
  };

  const handleViewClaim = () => {
    onMarkAsRead();
    onClose();
    history.push(`/${siteExtId}/claims`, {
      openDrawerId: Number(claimId),
    });
  };

  return (
    <>
      {isClaimEmailApproval && (
        <button
          type="button"
          className="button mr-2"
          onClick={handleApproveAndSendEmail}
          style={{ fontSize: '14px' }}
        >
          Approve & Send Email
        </button>
      )}
      {siteExtId && claimId && (
        <button
          type="button"
          className="button mr-2"
          onClick={handleViewClaim}
          style={{ fontSize: '14px' }}
        >
          View Claim
        </button>
      )}
    </>
  );
};
